import api from './axios';

// Oyun puan sıralamalarını getir
export const getGameRankings = async () => {
    try {
        const response = await api.post("api/v1/Games/ranking/game-total");
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Sıralama verileri alınamadı!" };
    }
};
